import React, { useState } from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import Platform from '@lyearn/core/utils/Platform';
import { useTranslation } from '@lyearn/i18n';
import { ArrowIosForward } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Stack, Typography } from '@lyearn/ui';
import ActivitiesCenterTabs from '@/components/ActivityCenter/components/ActivitiesCenterTabs';
import { ActivityCenterTabsEnum } from '@/components/ActivityCenter/components/ActivitiesCenterTabs';
import { Link } from '@/components/Link';
import useWindowSize from '@/hooks/useWindowSize';
import routes from '@/pages/corporate/routes';

import { NotificationDetailsFragment } from './graphql/fragments/generated/NotificationDetails';
import { notificationTrayContainer, notificationTrayContainerMobile } from './styles';

const NotificationTray: React.FC<{
  unreadNotificationsCount?: number;
  toggleTray: () => void;
  onClickBadgeType: (notif: NotificationDetailsFragment) => void;
  onClickPointsAwarded: (notif: NotificationDetailsFragment) => void;
}> = ({ unreadNotificationsCount, toggleTray, onClickBadgeType, onClickPointsAwarded }) => {
  const { t } = useTranslation();
  const { isMobile } = useScreen();
  const { height } = useWindowSize();
  const [currentTab, setCurrentTab] = useState(ActivityCenterTabsEnum.NOTIFICATIONS);

  return (
    <Box
      className={cn(
        'flex flex-1 flex-col pb-8 px-24 pt-20 xs:pt-32 xs:pb-24',
        Platform.select({
          web: isMobile ? notificationTrayContainerMobile : notificationTrayContainer,
          native: 'pt-8',
        }),
      )}
      style={Platform.select({
        web: undefined,
        native: { height: height * 0.85 },
      })}>
      <Stack className="mb-16 gap-8" direction="row" justifyContent="between">
        <Typography className="heading-xs xs:heading-s text-text-primary">
          {t('Common:Notifications.Activity')}
        </Typography>
        <Link
          className="flex items-center gap-4"
          to={routes.ActivityCenterTab(currentTab)}
          onClick={() => toggleTray()}>
          <Typography className="text-text-secondary" variant="body-short-03">
            {t('Common:Notifications.SeeAll')}
          </Typography>
          <ArrowIosForward className="h-20 w-20" fillColorToken="icon-placeholder" />
        </Link>
      </Stack>

      <ActivitiesCenterTabs
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        toggleTray={toggleTray}
        unreadNotificationsCount={unreadNotificationsCount}
        onClickBadgeType={onClickBadgeType}
        onClickPointsAwarded={onClickPointsAwarded}
      />
    </Box>
  );
};

export default NotificationTray;
